// Configuração do Supabase para diferentes ambientes
// Este arquivo centraliza a configuração de URLs e chaves para facilitar o deploy

import { createClient } from "@supabase/supabase-js";

// A chave anônima do Supabase é segura para incluir no cliente
// Nunca inclua chaves de serviço ou chaves com privilégios elevados no front-end

// Fallback de produção. Usado SOMENTE quando nenhuma variável de ambiente é
// fornecida no build (ex.: deploy atual do gh-pages). Para homologação/outros
// ambientes, defina REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_(ANON_)KEY no
// build e estes valores serão ignorados.
const FALLBACK_SUPABASE_URL = "https://rnvsemzycvhuyeatjkaq.supabase.co";
const FALLBACK_SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJudnNlbXp5Y3ZodXllYXRqa2FxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ4MDk0NTAsImV4cCI6MjA2MDM4NTQ1MH0.d2GTmTBAUIINoL52Ylz4tXsnhPLBTynOtvKlVa5sy60";

// Sempre dá prioridade às variáveis de ambiente (definidas no build).
// Aceita tanto REACT_APP_SUPABASE_KEY quanto REACT_APP_SUPABASE_ANON_KEY.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || FALLBACK_SUPABASE_URL;

const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_KEY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  FALLBACK_SUPABASE_ANON_KEY;

// Aviso em build: se caiu no fallback, o ambiente não foi configurado.
if (!process.env.REACT_APP_SUPABASE_URL) {
  // eslint-disable-next-line no-console
  console.warn(
    "[supabaseConfig] REACT_APP_SUPABASE_URL não definida — usando fallback de PRODUÇÃO."
  );
}

// Criar e exportar a instância do cliente Supabase
const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;

// Exportar URL e Chave separadamente (opcional, se ainda forem necessários em algum lugar)
export { supabaseUrl, supabaseAnonKey };
